import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import ICommonOptions from "../../types/commonOptions";
import IUserOption from "../../types/userOption";
import IUserOptions from "../../types/userOption";

export type TUserState = {
    options: IUserOptions | null
}

const initialState: TUserState = {
    options: null
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserOptionsAction: (state, action: PayloadAction<IUserOptions>) => {
            state.options = action.payload
        },
    }
})

export const {setUserOptionsAction} = userSlice.actions
export default userSlice.reducer